module.exports = __webpack_public_path__ + "img/linkedin.2c47c188.svg";